import type { KnownPermission, PermissionCode } from "@planerius/contracts/cabinet-auth"
import { CABINET_PERMISSIONS } from "@planerius/contracts/cabinet-auth"

/**
 * Права человека в выбранном салоне.
 *
 * Хранятся множеством, а не массивом: проверка идёт на каждом пункте меню, каждой кнопке
 * и каждой колонке, а список прав доходит до полусотни строк.
 *
 * ПОЧЕМУ МНОЖЕСТВО СТРОК, А НЕ ПЕРЕЧИСЛЕНИЕ. Схема PermissionCode на сервере нарочно
 * открытая: права появляются вместе с новыми разделами, и старый кабинет обязан пережить
 * незнакомый код молча. Поэтому внутрь множества кладётся всё, что прислал сервер,
 * а СПРАШИВАТЬ можно только про известные коды — их проверяет компилятор.
 */
export type PermissionSet = ReadonlySet<string>

export { CABINET_PERMISSIONS }
export type { KnownPermission, PermissionCode }

export function toPermissionSet(codes: readonly PermissionCode[]): PermissionSet {
  return new Set<string>(codes)
}

export const EMPTY_PERMISSIONS: PermissionSet = new Set<string>()

/** Есть ли право. Аргумент типизирован: опечатка в коде права не доживёт до сборки. */
export function hasPermission(permissions: PermissionSet, code: KnownPermission): boolean {
  return permissions.has(code)
}

export function hasAnyPermission(
  permissions: PermissionSet,
  codes: readonly KnownPermission[],
): boolean {
  return codes.some((code) => permissions.has(code))
}

export function hasAllPermissions(
  permissions: PermissionSet,
  codes: readonly KnownPermission[],
): boolean {
  return codes.every((code) => permissions.has(code))
}
